import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';

interface ImprovementProcedures {
    valueAr: string;
    valueEn: string;
    percentage: number;
    expectedCompletionDate: Date;
}

@Component({
    templateUrl: './improvement-procedures-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ImprovementProceduresDialogComponent {
    @Input() public type: 'kpi-result' | 'data-entry-response';

    @Input() public improvementProcedures: ImprovementProcedures;

    // Fields Only For Kpi Result
    @Input() public isApproved = true;
    @Input() public allowDynamicAnalysisEdit = false;

    // Fields Only For Data Entry Response
    @Input() public canEditImprovementProcedure = false;
    @Input() public readOnly: boolean = false;

    @Output() public itemUpdated = new EventEmitter<ImprovementProcedures>();

    public submit(): void {
        this.itemUpdated.emit(this.improvementProcedures);
    }
}
